import { resetUserFactorRequestParamsSchema, resetUserFactorResponseSchema } from './types';
export const resetUserFactorDef = {
    name: 'resetUserFactor',
    requestSchema: resetUserFactorRequestParamsSchema,
    responseSchema: resetUserFactorResponseSchema,
};
